
import React from 'react';
import './ShortCuts.css';
/*
 * Each mode has its own mouse gestures and keyboard shortcuts.
 * This makes it easy to add mode-specific behavior without
 * mixing conflicting meanings.
 */

const shortcutData = {

  // --------------------------------------------------
  // PRIMARY EDITOR MODE
  // --------------------------------------------------

  primary: {
    title: 'Primary Mode',

    mouseGestures: [
      {
        action: 'Left click',
        description: 'Select a rectangle',
      },
      {
        action: 'Left click',
        description: 'Place selected object',
      },
      {
        action: 'Drag',
        description: 'Move selected rectangle, or pan the page'
      },
      {
        action: 'Bottom-right handle + drag',
        description: 'Resize rectangle',
      },
      {
        action: 'Shift + click',
        description: 'Multi-select rectangles',
      },
      {
        action: 'Shift + drag',
        description: 'Move multiple rectangles',
      },
      {
        action: 'Ctrl + drag',
        description: 'Select rectangles by area',
      },
      {
        action: 'Mouse wheel',
        description: 'Zoom around cursor',
      },
      {
        action: 'Middle mouse drag',
        description: 'Pan the page',
      },
      {
        action: 'Right click',
        description: 'Open context menu',
      },
    ],

    keyboardShortcuts: [
      {
        key: 'Delete',
        description: 'Delete selected rectangles',
      },
      {
        key: 'Shift',
        description: 'Temporarily disable grid snapping',
      },
      {
        key: 'Ctrl + C',
        description: 'Copy selected rectangle',
      },
      {
        key: 'Ctrl + Z',
        description: 'Undo last change',
      },
      {
        key: 'Tab',
        description: 'Select current rectangle',
      },
      {
        key: '←',
        description: 'Select previous rectangle',
      },
      {
        key: '→',
        description: 'Select next rectangle',
      },
    ],
  },


  // --------------------------------------------------
  // POLYLINE MODE
  // --------------------------------------------------

  pline: {
    title: 'Polyline Drawing',

    mouseGestures: [
      {
        action: 'Left click',
        description: 'Place a point',
      },
      {
        action: 'Left click + drag',
        description: '???',
      },
      {
        action: 'Double click',
        description: '???',
      },
      {
        action: 'Right click',
        description: '???',
      },
      {
        action: 'Mouse wheel',
        description: 'Zoom around cursor',
      },
      {
        action: 'Middle mouse drag',
        description: 'Pan the page',
      },
    ],

    keyboardShortcuts: [
      // Add polyline-specific shortcuts here
    ],
  },


  // --------------------------------------------------
  // BEZIER MODE
  // --------------------------------------------------

  bezier: {
    title: 'Bezier Drawing',

    mouseGestures: [
      {
        action: 'Left click',
        description: 'Place a point',
      },
      {
        action: 'Left click + drag',
        description: 'Set curve direction',
      },
      {
        action: '???',
        description: '???',
      },
      {
        action: 'Mouse wheel',
        description: 'Zoom around cursor',
      },
      {
        action: 'Middle mouse drag',
        description: 'Pan the page',
      },
    ],

    keyboardShortcuts: [
      // Add Bezier-specific shortcuts here
    ],
  },


  // --------------------------------------------------
  // FREEHAND MODE
  // --------------------------------------------------

  freehand: {
    title: 'Freehand Drawing',

    mouseGestures: [
      {
        action: 'Left click + drag',
        description: 'Draw freehand',
      },
      {
        action: 'Mouse wheel',
        description: 'Zoom around cursor',
      },
      {
        action: 'Middle mouse drag',
        description: 'Pan the page',
      },
    ],

    keyboardShortcuts: [
      // Add freehand-specific shortcuts here
    ],
  },

};


// --------------------------------------------------
// Reusable shortcut list
// --------------------------------------------------

const KeyCap = ({ children }) => {
  const parts = children.split(' + ');

  return (
    <span className="shortcut-keys">
      {parts.map((part, index) => (
        <React.Fragment key={index}>
          {index > 0 && (
            <span className="shortcut-plus">+</span>
          )}

          <span className="key-cap">
            {part}
          </span>
        </React.Fragment>
      ))}
    </span>
  );
};


const ShortcutList = ({ items, type }) => {
  return (
    <div className="shortcut-card">
      {items.map((item, index) => (
        <div className="shortcut-row" key={index}>

          <div className="shortcut-action">
            <KeyCap>
              {type === 'key' ? item.key : item.action}
            </KeyCap>
          </div>

          <div className="shortcut-description">
            {item.description}
          </div>

        </div>
      ))}
    </div>
  );
};


// --------------------------------------------------
// Main component
// --------------------------------------------------

const ShortCuts = ({ mode = 'primary' }) => {

  const data = shortcutData[mode] || shortcutData.primary;

  return (
    <div className="shortcuts-panel">

      <div className="shortcuts-title">
        <span className="shortcuts-title-icon">💡</span>

        <div>
          <div className="shortcuts-heading">
            Quick Hints
          </div>

          <div className="shortcuts-subheading">
            {data.title}
          </div>
        </div>
      </div>


      {/* Mouse Gestures */}

      {data.mouseGestures?.length > 0 && (
        <section className="shortcut-section">

          <div className="shortcut-section-title">
            <span className="shortcut-section-icon">
              🖱️
            </span>

            Mouse Gestures
          </div>

          <ShortcutList
            items={data.mouseGestures}
            type="action"
          />

        </section>
      )}


      {/* Keyboard Shortcuts */}

      {data.keyboardShortcuts?.length > 0 && (
        <section className="shortcut-section">

          <div className="shortcut-section-title">
            <span className="shortcut-section-icon">
              ⌨️
            </span>

            Keyboard Shortcuts
          </div>

          <ShortcutList
            items={data.keyboardShortcuts}
            type="key"
          />

        </section>
      )}

    </div>
  );
};

export default ShortCuts;



